import { Endpoints } from "services/api";
import { getFetch } from "@wexinc/wex-common-web";
import { PageInfo } from "@wexinc/wex-ui";
import { GlobalRole, UserFromAPI } from "./models";

const apiRoot = "users";
const { get, post, put, doDelete } = getFetch(Endpoints.apiRoot);

export async function getPageOfUsers(
  page?: number,
  size?: number,
  query?: string,
  includeInactive?: boolean,
): Promise<PageInfo<UserFromAPI>> {
  const queryParams: { [id: string]: string } = {};
  if (page) {
    queryParams["page"] = page.toString();
  }
  if (size) {
    queryParams["size"] = size.toString();
  }
  if (query) {
    queryParams["query"] = query.toString();
  }
  if (includeInactive) {
    queryParams["includeInactive"] = "true";
  }
  const result = await get({
    relativeRoute: `${apiRoot}`,
    queryParams,
  });

  return result as PageInfo<UserFromAPI>;
}

export async function reactivateUser(userId: string) {
  return post({
    relativeRoute: `${apiRoot}/${userId}/reactivate`,
    body: {},
  });
}

export async function updateGlobalUserRoles(userId: string, globalRoleIds: string[]): Promise<GlobalRole[]> {
  return put({
    relativeRoute: `${apiRoot}/${userId}/global-roles`,
    body: { globalRoleIds },
  });
}

export async function promoteToSuperAdmin(email: string) {
  return post({
    relativeRoute: `${apiRoot}/super-admin`,
    body: { email },
  });
}
export async function removeSuperAdmin(email: string) {
  return doDelete({
    relativeRoute: `${apiRoot}/super-admin`,
    body: { email },
  });
}

export async function terminateUserSessions(userId: string) {
  return doDelete({
    relativeRoute: `${apiRoot}/${userId}/sessions`,
  });
}
